<template>
  <!-- 一对一咨询内容页 -->
  <div class="onlitcoudet">
    <div class="w12 between">
      <div class="onlitcoudetlf">
        <onlintdetstrter class="bgff bgshow" />
        <onlitdetlist class="bgff mt30 bgshow" />
        <otodetxgflzx class="mt30 bgshow" />
        <otodetflzs class="bgff mt30 bgshow" />
        <otodetrmflzx class="bgff mt30 bgshow" />
      </div>
      <div class="onlitcoudetrg">
        <otodetusercol />
        <otodetzyls class="mt30 bgff bgshow" />
        <onlitxswd class="mt30 bgff bgshow" />
        <articlelist class="mt30 bgff bgshow" :num="5" title="精选解答推荐" />
      </div>
    </div>
  </div>
</template>

<script>
import onlintdetstrter from "./child/onlintdetstrter";
import onlitdetlist from "./child/onlitdetlist";
import otodetusercol from "views/otocoudet/components/otodetusercol";
import otodetzyls from "views/otocoudet/components/otodetzyls";
import otodetxgflzx from "views/otocoudet/child/otodetxgflzx";
import otodetflzs from "views/otocoudet/child/otodetflzs";
import otodetrmflzx from 'views/otocoudet/child/otodetrmflzx'
import articlelist from "views/videoclaim/componens/articlelist";
import onlitxswd from './components/onlitxswd'
export default {
  components: {
    onlintdetstrter,
    onlitdetlist,
    otodetusercol,
    otodetxgflzx,
    otodetzyls,
    otodetflzs,
    otodetrmflzx,
    articlelist,
    onlitxswd,
  },
};
</script>

<style lang="scss" scoped>
.onlitcoudet {
  background: #f8f8f8;
  .w12 {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
    align-items: flex-start;
    .bgff {
      background: #ffffff;
    }
    .bgshow{
      box-shadow: 0px 5px 13px 0px rgba(1, 1, 1, 0.1);
    }
    .onlitcoudetlf {
      width: 890px;
    }
    .onlitcoudetrg {
      width: 280px;
    }
  }
}
</style>